import { checkPermissions } from "@elit-hair/elit-tools";
import { Drawer } from "@mui/material";
import { createContext, useCallback, useContext, useState } from "react";

import routes from "@/constants/routes";
import useAuth from "@/providers/hooks/useAuth";

import { SideMenuItem } from "./components/SideMenuItem";

const sideMenuContext = createContext({
    toggleDrawer: () => {},
    handleOpenSideMenu: () => {},
    handleCloseSideMenu: () => {},
});
export const SideMenu = ({ children }: { children: React.ReactNode }) => {
    const [isOpen, setIsOpen] = useState(false);

    const toggleDrawer = useCallback(
        () => () => {
            setIsOpen(!isOpen);
        },
        [isOpen]
    );

    const handleOpenSideMenu = useCallback(() => {
        setIsOpen(true);
    }, []);
    const handleCloseSideMenu = useCallback(() => {
        setIsOpen(false);
    }, []);

    const { userData } = useAuth();

    return (
        <sideMenuContext.Provider value={{ handleOpenSideMenu, handleCloseSideMenu, toggleDrawer }}>
            <Drawer
                anchor="left"
                open={isOpen}
                onClose={handleCloseSideMenu}
                sx={{
                    "& .MuiPaper-root": { m: 1, display: "flex", height: "-webkit-fill-available", borderRadius: 8 },
                }}
            >
                <div className="w-64 flex flex-col justify-between h-full p-2">
                    <div className="flex flex-col gap-2">
                        {routes.map((route) => {
                            if (!route.icon || route.hideInSidebar || route.hidden) return null;

                            if (!checkPermissions(userData?.permissionCodes, route.permissions)) return null;

                            const isCurrent = location.pathname === route.path;

                            return (
                                <SideMenuItem
                                    key={route.path}
                                    route={route.path}
                                    title={route.mobileTitle || route.title || ""}
                                    icon={<route.icon />}
                                    isCurrent={isCurrent}
                                />
                            );
                        })}
                    </div>
                </div>
            </Drawer>
            {children}
        </sideMenuContext.Provider>
    );
};

export const useSideMenu = () => {
    return useContext(sideMenuContext);
};
